import { statusColorMapping } from "components/shop-reception/admin/ReceptionDashboard/TruckList/helpers";

export const columns = [
  {
    title: 'Status',
    field: 'deliveryStatusValue',
    render: row => (
      <div style={{ color: statusColorMapping[row.deliveryStatusValue] || 'black' }}>{row.deliveryStatusValue}</div>
    )
  },
  {
    title: 'Locatie camion',
    field: 'truckTypeValue'
  },
  {
    title: 'Creat de',
    field: 'createdBy'
  },
  {
    title: 'Data crearii',
    field: 'created'
  },
  {
    title: 'Actualizat de',
    field: 'updatedBy'
  },
  {
    title: 'Ultima actualizare',
    field: 'updated'
  }
]
